<template>
  <span v-if="level === 'none'" class="text-gray-300">—</span>
  <component
    :is="clickable ? 'button' : 'span'"
    v-else
    :type="clickable ? 'button' : undefined"
    class="inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap"
    :class="[levelClasses.badge, clickable ? 'cursor-pointer transition-opacity hover:opacity-75' : '']"
    @click="clickable && $emit('select')"
  >
    <span class="h-1.5 w-1.5 rounded-full" :class="levelClasses.dot"></span>
    {{ percent }} %
  </component>
</template>

<script>
import { LEVEL_CLASSES, completionLevel } from "@/utils/trainingCompletion";

export default {
  name: "CompletionBadge",
  props: {
    percent: { type: Number, default: null },
    clickable: { type: Boolean, default: false },
  },
  emits: ["select"],
  computed: {
    level() {
      return completionLevel(this.percent);
    },
    levelClasses() {
      return LEVEL_CLASSES[this.level];
    },
  },
};
</script>
